import { render } from "./UserProfileSelection.vue?vue&type=template&id=042816a2"
import script from "./UserProfileSelection.vue?vue&type=script&lang=js"
export * from "./UserProfileSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__